import { create, type StoreApi } from 'zustand'
import { OfferButtonStore } from './types'

const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24

const hasExpired = (timestamp: number) =>
  Date.now() - timestamp > TWENTY_FOUR_HOURS

const getStoredTimestamp = (storageKey: string) => {
  if (typeof window === 'undefined') return null
  const stored = localStorage.getItem(storageKey)
  if (!stored) return null
  const timestamp = parseInt(stored)
  return isNaN(timestamp) ? null : timestamp
}

export const createButtonStore = (modal_id: string) =>
  create<OfferButtonStore>((set) => {
    const STORAGE_KEY = `${modal_id}_closed_at`
    const stored = getStoredTimestamp(STORAGE_KEY)
    const dismissed = stored !== null && !hasExpired(stored)

    return {
      isOpen: false,
      isDismissed: dismissed,

      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),

      setDismissed: (value) => set({ isDismissed: value }),

      dismiss: () => {
        if (typeof window !== 'undefined') {
          localStorage.setItem(STORAGE_KEY, Date.now().toString())
        }
        set({ isDismissed: true })
      },

      checkDismissed: () => {
        const stored = getStoredTimestamp(STORAGE_KEY)
        if (stored && !hasExpired(stored)) {
          set({ isDismissed: true })
        } else {
          set({ isDismissed: false })
        }
      },
    }
  })

const createOfferButtonStore = createButtonStore('promotional_offer')

export const useOfferButtonStore = () => createOfferButtonStore()
